export default __webpack_public_path__ + "assets/images/030b95e13c9dd95edaa1f739acf47ca3.png";